import { tv } from "tailwind-variants";

import { monsterrat } from "@/services/styles/fonts";

export const getBioClass = tv({
  base: "relative rounded-xl bg-tertiary-50 text-gray-600",
});

export const getHeadingClass = tv({ base: ["pb-4 font-semibold text-xl lg:pb-7 lg:text-4xl", monsterrat.className] });

export const getBioItemClass = tv({
  base: ["relative mx-4 flex gap-5 border-b border-b-gray-200 py-4 last:border-b-0 lg:mx-8 lg:py-8"],
});
